var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section"
  }, [_c('div', [_c('client-form', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "saved": _vm.onFormCompete
    }
  })], 1), _c('div', [_c('b-button', {
    on: {
      "click": _vm.askForConfirmationTheDelete
    }
  }, [_vm._v("Sterge asociatia")])], 1), _c('b-loading', {
    attrs: {
      "is-full-page": _vm.isFullPage,
      "active": _vm.savingResult,
      "can-cancel": true
    },
    on: {
      "update:active": function ($event) {
        _vm.savingResult = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }